import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface States {
  currency: string;
}

export interface Actions {
  setCurrency: (currency: string) => void;
}

export const useStore = create(
  persist<States & Actions>(
    (set) => ({
      currency: "USD",
      setCurrency: (currency) => set({
        currency
      })
    }),
    {
      name: "travelthru-store_v1",
      version: 1,
      storage: createJSONStorage(() => localStorage),
    }
  )
);